var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import SaveIcon from "@material-ui/icons/Save";
import IconButton from '@mui/material/IconButton';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from "@mui/material/Select";
import moment from "moment";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import { MuiThemeProvider} from '@material-ui/core/styles';
import AppRoleDialog from '../CreateDialogue/AppRoleDialog';
import EditAppRoleDialog from '../EditDialogue/EditAppRoleDialog';
import { muiThemeDesign } from '../../mui-theme-design';
import {logger, customBodyForExcelReport,handleExport,permissions,muiLoaderOptions} from '../../utils';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
const ExcelJS = require('exceljs');

export default function AppRoleTable() {    
    const [refresh, setRefresh] = React.useState(true);
    const [appRoles, setappRoles] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [AlertText, setAlertText] = React.useState('');


    const handleDialogCallback = (childData) => {
        fetch("api/AppRole", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "AppRoleName": childData.AppRoleName,
                "IsActive": childData.IsActive,
                "ViewFinancials": childData.ViewFinancials,
                "GlobalAccess": childData.GlobalAccess,
                "CanBeAssignedTo": childData.CanBeAssignedTo,
                "CreateEvent": childData.CreateEvent,
                "ViewAppRoles": childData.ViewAppRoles,
                "CreateAppRoles": childData.CreateAppRoles,
                "ViewUser": childData.ViewUser,
                "CreateUser": childData.CreateUser,
                "ViewUserRoles": childData.ViewUserRoles,
                "EditUserRoles": childData.EditUserRoles,
                "CreateUserRoles": childData.CreateUserRoles,
                "ViewUserProperties": childData.ViewUserProperties,
                "CreateUserProperties": childData.CreateUserProperties,
                "ViewEntry": childData.ViewEntry,
                "CreateEntry": childData.CreateEntry,
                "ViewSOW": childData.ViewSOW,
                "CreateSOW": childData.CreateSOW,
                "ViewCostCenter": childData.ViewCostCenter,
                "CreateCostCenter": childData.CreateCostCenter,
                "ViewPO": childData.ViewPO,
                "CreatePO": childData.CreatePO,
                "ViewLab": childData.ViewLab,
                "CreateLab": childData.CreateLab,
                "ViewProjects": childData.ViewProjects,
                "CreateProjects": childData.CreateProjects,
                "ViewTasks": childData.ViewTasks,
                "CreateTasks": childData.CreateTasks,
                "ViewTaskGroup": childData.ViewTaskGroup,
                "CreateTaskGroup": childData.CreateTaskGroup,
                "ViewTaskVariables": childData.ViewTaskVariables,
                "CreateTaskVariables": childData.CreateTaskVariables,
                "CreateInvoice": childData.CreateInvoice,
                "CreateExpense": childData.CreateExpense,
                "ViewPosition": childData.ViewPosition,
                "CreatePosition": childData.CreatePosition,
                "CreateRate": childData.CreateRate,
                "CreateClientSite": childData.CreateClientSite
            })
        }) .then(res => res.json())
        .then(json => {
            if (json.code === 'ER_DUP_ENTRY') {
                setAlertText(json.message)
                setAlert(true)
            }
        })
        logger(childData);
        setRefresh(true)
    };

    const handleEditCallback = (childData) => {
        fetch("api/AppRole", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "ID": childData.ID,
                "AppRoleName": childData.AppRoleName,
                "IsActive": childData.IsActive,
                "ViewFinancials": childData.ViewFinancials,
                "GlobalAccess": childData.GlobalAccess,
                "CanBeAssignedTo": childData.CanBeAssignedTo,
                "CreateEvent": childData.CreateEvent,
                "ViewAppRoles": childData.ViewAppRoles,
                "CreateAppRoles": childData.CreateAppRoles,
                "ViewUser": childData.ViewUser,
                "CreateUser": childData.CreateUser,
                "ViewUserRoles": childData.ViewUserRoles,
                "EditUserRoles": childData.EditUserRoles,
                "CreateUserRoles": childData.CreateUserRoles,
                "ViewUserProperties": childData.ViewUserProperties,
                "CreateUserProperties": childData.CreateUserProperties,
                "ViewEntry": childData.ViewEntry,
                "CreateEntry": childData.CreateEntry,
                "ViewSOW": childData.ViewSOW,
                "CreateSOW": childData.CreateSOW,
                "ViewCostCenter": childData.ViewCostCenter,
                "CreateCostCenter": childData.CreateCostCenter,
                "ViewPO": childData.ViewPO,
                "CreatePO": childData.CreatePO,
                "ViewLab": childData.ViewLab,
                "CreateLab": childData.CreateLab,
                "ViewProjects": childData.ViewProjects,
                "CreateProjects": childData.CreateProjects,
                "ViewTasks": childData.ViewTasks,
                "CreateTasks": childData.CreateTasks,
                "ViewTaskGroup": childData.ViewTaskGroup,
                "CreateTaskGroup": childData.CreateTaskGroup,
                "ViewTaskVariables": childData.ViewTaskVariables,
                "CreateTaskVariables": childData.CreateTaskVariables,
                "CreateInvoice": childData.CreateInvoice,
                "CreateExpense": childData.CreateExpense,
                "ViewPosition": childData.ViewPosition,
                "CreatePosition": childData.CreatePosition,
                "CreateRate": childData.CreateRate,
                "CreateClientSite": childData.CreateClientSite
            })
        }).then(res => res.json())
        .then(json => {
            if (json.code === 'ER_DUP_ENTRY') {
                setAlertText(json.message)
                setAlert(true)
            }
        })
        setRefresh(true)
    };

    React.useEffect(() => {
        if (refresh) {
            fetch('/api/AppRole', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
					setappRoles(json);
					setIsLoading(false);
				})

            setRefresh(false);
        }
    })
    
    const handleAlertClose = () => {
        setAlert(false);
    };
	
    
      const columns = [];
	if (permissions.CreateAppRoles == 1) {
		const adminActions = {
            name: "Admin Actions",
            options: {
                filter: false,
                sort: false,
                empty: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div>
                            <EditAppRoleDialog handleEditCallback={handleEditCallback} data={appRoles[dataIndex]} />
                        </div>
                    );
                }

            }
        };
		columns.push(adminActions);
	}

	const columns1 = [
            {
            name: "AppRoleName",
            label: "Name",
            options: {
                filter: true,
                sort: true,
          
       				 }
                }
    ];
    
    columns.push(...columns1);

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('AppRolerowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('AppRolerowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();
	
	const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage, // Use the initial value retrieved from local storage
         textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',
        
		onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			handleExport({rows:rows, headers:headers, filename:'AppRoles.xlsx', columnIndexToRemove:0});
			return false;
		},
		
		customToolbar: () =>{
        return !isLoading ? <AppRoleDialog handleDialogCallback={handleDialogCallback} /> : null;
    }
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (       
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}>
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="AppRolesTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft App Roles
                        </Typography>
                    }
                    data={isLoading ? [] :appRoles}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}
                    
                />
                </Box>
            </MuiThemeProvider>
            <Dialog
                open={LockedAlert}
                onClose={handleAlertClose}
                aria-labelledby="L&P Lock"
                aria-describedby="Time Period locked for this work"
            >
                <DialogTitle id="App_Role">
                    {"Duplicate Entry"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {AlertText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                </DialogActions>
            </Dialog>
        </Box>
        
    );
}